import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from './ui/dialog';
import { ArrowRight, Play } from 'lucide-react';
import { ContactForm } from './ContactForm';

export const HeroSection = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black">
      {/* Background Image Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzU5ODgyNzczfDA&ixlib=rb-4.1.0&q=85')`
        }}
      />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            NOVOPAY
            <span className="text-yellow-400 block">Tu dinero sin límites</span>
          </h1>
          
          <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto">
            Una nueva forma de entender el dinero. Tecnología, elegancia y control en una sola plataforma.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Button 
              asChild
              size="lg" 
              className="bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-4 text-lg font-semibold rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              <Link to="/abre-cuenta" data-testid="hero-signup-link">
                Abre tu Cuenta Hoy Mismo
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
              <DialogTrigger asChild>
                <Button 
                  variant="outline" 
                  size="lg" 
                  className="border-2 border-slate-400 text-slate-300 hover:text-white hover:border-white px-8 py-4 text-lg font-semibold rounded-lg transition-colors duration-200 bg-transparent"
                >
                  <Play className="mr-2 h-5 w-5" />
                  Solicita una Demo Empresarial
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                <DialogTitle className="sr-only">Solicitar Demo Empresarial</DialogTitle>
                <DialogDescription className="sr-only">Formulario para solicitar una demo de NOVOPAY</DialogDescription>
                <ContactForm isDemo={true} onClose={() => setIsDialogOpen(false)} />
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </section>
  );
};
